import { LitElement, css, html } from "lit-element";
import { repeat } from "lit-html/directives/repeat.js";
import { classMap } from 'lit-html/directives/class-map';
import '@vaadin/vaadin-date-picker/vaadin-date-picker.js';
import { axios } from '@bundled-es-modules/axios';

class DeliveryProblemComponent extends LitElement {

    static get properties() {
        return {
            _MainServiceDomain: { type: String },
            _loginDetails: { type: Object },
            _subscriptionDetails: { type: Object },
            _deliveryIssueReasons: { type: Array },
            _isReasonsList: { type: Boolean },
            _deliveryOptions: { type: Array },
            _isOptionsList: { type: Boolean },
            _selectedDeliveryIssueReason: { type: Object },
            _selectedDeliveryOption: { type: Object },
            _submitReportRes: { type: String },
            isSystemError: { type: Boolean },
        }
    }

    get MainServiceDomain() {
        return this._MainServiceDomain;
    }

    set MainServiceDomain(value) {
        this._MainServiceDomain = value;
    }

    get loginDetails() {
        return this._loginDetails;
    }

    set loginDetails(value) {
        this._loginDetails = value;
    }

    get subscriptionDetails() {
        return this._subscriptionDetails;
    }

    set subscriptionDetails(value) {
        this._subscriptionDetails = value;
    }

    get deliveryIssueReasons() {
        return this._deliveryIssueReasons;
    }

    set deliveryIssueReasons(value) {
        this._deliveryIssueReasons = value;
    }

    get isReasonsList() {
        return this._isReasonsList;
    }

    set isReasonsList(value) {
        this._isReasonsList = value;
    }

    get deliveryOptions() {
        return this._deliveryOptions;
    }

    set deliveryOptions(value) {
        this._deliveryOptions = value;
    }

    get isOptionsList() {
        return this._isOptionsList;
    }

    set isOptionsList(value) {
        this._isOptionsList = value;
    }

    get selectedDeliveryIssueReason() {
        return this._selectedDeliveryIssueReason;
    }

    set selectedDeliveryIssueReason(value) {
        this._selectedDeliveryIssueReason = value;
    }

    get selectedDeliveryOption() {
        return this._selectedDeliveryOption;
    }

    set selectedDeliveryOption(value) {
        this._selectedDeliveryOption = value;
    }

    get submitReportRes() {
        return this._submitReportRes;
    }

    set submitReportRes(value) {
        this._submitReportRes = value;
    }

    constructor() {
        super();
        this.isReasonsList = false;
        this.isOptionsList = false;
        this.isSystemError = false;
        document.addEventListener('onSelectSubscription', async(e) => {
            this.isReasonsList = false;
            this.isOptionsList = false;
            this.loginDetails = e.detail.loginDetails;
            this.subscriptionDetails = e.detail.selectedSubscription;
            await this.getOptions();
        })
    }

    updated() {

        if (!this.isReasonsList && !this.isOptionsList) {
            this.cancelReport();
        }
    }

    static get styles() {
        return css `
        * {
            margin: 0;
            padding: 0;
        }
        .text-center {
            text-align: center;
        }
        
        .d-none {
            display: none;
        }
        
        .d-block {
            display: block;
        }
        
        .mg-b5 {
            margin-bottom: 5px;
        }
        
        .mg-t5 {
            margin-top: 5px;
        }
        
        p {
            font-size: 14px;
        }

        .width100 {
            width: 100%;
        }

        .disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: not-allowed;
            position: relative;
        }

        /* Element Style */
        .report-box {
            border-radius: 35px;
            position: relative;
            padding: 25px 25px;
            width: 100%;
            border: 1px solid var(--w-bg-borc, #505050);
            background-color: var(--w-bgc, #fff);
            box-sizing: border-box;
        }
        
        .report-heading {
            font-size: var(--w-tit-fs, 14px);
            color: var(--w-tit-col, #000);
            background-color: var(--w-tit-bgc, #fff);
            padding: 10px;
            border-radius: 5px;
        }
        
        .report-error {
            background-color: var(--w-txt-bgc, #fff);
            border: none;
            color: var(--w-txt-col, #434343);
            font-size: var(--w-txt-fs, 14px);
            padding: 10px;
            border-radius: 5px;
        }

        .error {
            font-size: var(--w-msg-fs, 13px);
            color: var(--w-msg-col, #000);
        }

        .error-text-color {
            color: var(--w-err-sys-col, red);
        }
        
        .btn {
            display: inline-block;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid transparent;
            padding: 6px 12px;
            font-size: 16;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn:hover, .btn:focus {
            text-decoration: none;
        }
          
        .btn:focus, .btn.focus {
            outline: 0;
            box-shadow: none;
        }
          
        .btn.disabled, .btn:disabled {
            opacity: 0.65;
        }
        
        .btn-success {
            color: var(--w-btn-col, #505050);
            background-color: var(--w-btn-bgc, #fff);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-success:hover {
            color: var(--w-btn-col, #fff);
            background-color: var(--w-btn-bgc, #505050);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-lg {
            padding: 8px 16px;
            font-size: 14px;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn-block {
            display: block;
            width: 100%;
        }
        
        .form-group {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-flex: 0;
            -ms-flex: 0 0 auto;
            flex: 0 0 auto;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-flow: row wrap;
            flex-flow: row wrap;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            margin-bottom: 0;
            color: var(--form-group-color, #fff);
        }
        
        .form-control {
            display: block;
            width: 100%;
            padding: 8px 12px;
            font-size: 14px;
            line-height: 1.5;
            color: var(--form-control-color, #000);
            background-color: var(--form-control-bgColor, #fff);
            border: 1px solid var(--form-control-borderColor, #505050);
            background-clip: padding-box;
            border-radius: 4px;
        }
        
        .form-control:focus {
            color: var(--form-control-focus-color, #495057);
            background-color: var(--form-control-focus-bgColor, #fff);
            border-color: var(--form-control-borderColor, #505050);
            outline: 0;
            box-shadow: 0 0 0 0.2rem var(--form-control-focus-boxShadow, rgba(65, 157, 255, 0.25));
          }
        
        
        .form-control::-webkit-input-placeholder {
            color: var(--form-control-placehorderColor, #959595);
            opacity: 1;
        }
        
        .form-control::-moz-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control:-ms-input-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control::-ms-input-placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .form-control::placeholder {
            color: var(--form-control-placeholderColor, #959595);
            opacity: 1;
        }
        
        .dropdown {
          width: 100%;
          position: relative;
        }
        
        /*List*/
        .header-dropdown-btn {
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: left;
            padding-left: 3px;
            font-size: 13px;
            overflow: hidden;
        }

        .dropdown-toogle {
            width: 100%;
            display: block;
            padding: 10px 0;
            border-radius: 5px;
            background-color: var(--dropdown-button-bgColor, #fff);
            color:  var(--dropdown-button-Color, #000);
            border: 1px solid #dcdcdc;
            font-size: var(--widget-txt-fs, 14px);
            cursor: pointer;
        }
        
        .dropdown-toogle:focus {
            outline: none;
            box-shadow: none;
        }


        .dropdown-list {
            color: var(--dropdown-list-color, #000);
            background-color: var(--dropdown-list-bgColor, #fff);
            list-style: none;
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            border-radius: 0 0 4px 4px;
            margin-top: 0px;
            box-shadow: 0 8px 20px 0 #ededed;
            z-index: 999;
        }
        
        .dropdown-item {
          padding: 5px;
          cursor: pointer;
          font-size: var(--w-txt-fs, 14px);
        }

        .dropdown-item:hover {
            background-color: var(--widget-background-bgColor, #000);
            color: #fff;
            cursor: pointer;
        }

        .dropdown-item.active {
            background-color: var(--widget-background-bgColor, #000);
            color: #fff;
        }
        
        .button-arrow {
            position: relative;
            padding: 4px 16px 4px 5px;
        }
        .button-arrow::before {
            content: " ";
            position: absolute;
            display: inline-block;
            transform: rotate(45deg);
            right: 10px;
            top: 8px;
            border-style: solid;
            border-width: 0px 1px 1px 0px;
            padding: 3px;
        }
        @media(max-width: 767px) {
            .report-box {
                padding: 15px;
                border-radius: 20px;
            }
        }
        `;
    }

    render() {
        return html 
            `<div id="delivery-problem-widget" class=${classMap({ 'report-box': true, 'disabled': this.subscriptionDetails ? (this.subscriptionDetails.status === 'Inactive' || this.subscriptionDetails.type === 'Digital') : false })}>
        <div class="text-center mg-b5">
            <h2 class="report-heading">Report A Delivery Problem</h2>
        </div>        
        ${this.isReasonsList && this.isOptionsList ? html`<div id="report-form" class="report-expand-div mg-b5">
        <div class="report-error text-center mg-t5 mg-b5">
                <p>To arrange for next day delivery please call the customer service number at the bottom of the page.</p>
        </div>
         <div class="form-group">
            <vaadin-date-picker class="width100" id="date-of-issue" placeholder="Stop Date" max=${this.dateFormatForVaadin(new Date(Date.now()))} value=${this.dateFormatForVaadin(new Date(Date.now()))}>
            </vaadin-date-picker>
        </div>
            <p class="mg-t5">Please select a reason</p>
            <div class="dropdown mg-t5">
        <button type="submit" class="dropdown-toogle header-dropdown-btn button-arrow" @click="${this.showReasons}">${this.displayDeliveryReason()}<i class="fa fa-chevron-down"></i></button>
               ${this.deliveryIssueReasons != undefined ? html`<ul id="reasons-list" class="dropdown-list d-none">
                                   ${repeat(
                this.deliveryIssueReasons,
                (item, index) => html`<li class="dropdown-item " @click="${this.selectedReason}">${item.description}</li>`
            )}
                </ul>` : html``}
            </div>
            <p class="mg-t5">Delivery Options</p>
            
            <div class="dropdown mg-t5">
        <button type="submit" class="dropdown-toogle header-dropdown-btn button-arrow" @click="${this.showDeliveryOptions}">${this.displayDeliveryOption()}<i class="fa fa-chevron-down"></i></button>
               ${this.deliveryOptions != undefined ? html`<ul id="options-list" class="dropdown-list d-none">
                                   ${repeat(
                this.deliveryOptions,
                (item, index) => html`<li class="dropdown-item" @click="${this.selectedOption}">${item.description}</li>`
            )}
                </ul>` : html``}
            </div>
            <div class="text-center">
                <button type="submit" class="btn btn-success btn-lg mg-t5" @click="${this.submitReport}">Submit</button>
                <button type="submit" class="btn btn-success btn-lg mg-t5" @click="${this.cancelReport}">Cancel</button>
                <p class=${classMap({ 'error': true, 'error-text-color': this.isSystemError })}>${this.submitReportRes}</p>
            </div>
        </div>` : html`
        <div id="open-report-form-btn">
          <button type="submit" class="bt btn-success btn-lg btn-block mg-b5" @click="${this.onReportProblem}">Report A Problem</button>
        </div>`}
    </div>`;
    }

    dateFormat(inputDate) {

        let date = new Date(inputDate);
        inputDate = new Date(inputDate);

        date.setMonth(inputDate.getUTCMonth(), inputDate.getUTCDate());
        date.setFullYear(inputDate.getUTCFullYear());
        date.setHours(inputDate.getUTCHours());
        date.setMinutes(inputDate.getUTCMinutes());
        date.setSeconds(inputDate.getUTCSeconds());
        date.setMilliseconds(inputDate.getUTCMilliseconds());

        return date;
    }

    dateFormatForDisplay(inputDate) {
        const date = this.dateFormat(inputDate);
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    dateFormatForVaadin(inputDate) {
        const date = this.dateFormat(inputDate);
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    async getOptions() {
        try {

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': `Bearer ${this.loginDetails.token}`,
            }

            const issueReasons = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/publication/${this.subscriptionDetails.publication}/deliveryissuetypes`, {
                headers: headers
            });

            const deliveryOptions = await axios.get(`${this.MainServiceDomain}/appservices/api/v2/deliveryissueresolutions`, {
                headers: headers
            });

            if (issueReasons.data) {
                this.deliveryIssueReasons = issueReasons.data;
            }

            if (deliveryOptions.data) {
                this.deliveryOptions = deliveryOptions.data;
            }

        } catch (error) {
            console.log(error);
        }
    }

    async onReportProblem() {
        if (this.deliveryIssueReasons) {
            this.isReasonsList = true;
            this.isOptionsList = true;
        }
    }

    async showReasons() {
        try {
            this.isReasonsList = true;
            const res = await this.requestUpdate();
            if (this.deliveryIssueReasons && res) {
                const list = this.shadowRoot.getElementById("reasons-list");

                if (!list.classList.contains("d-none")) {
                    list.classList.add("d-none");
                } else {
                    list.classList.remove("d-none");
                }
            }
        } catch (error) {
            throw error
        }
    }

    async showDeliveryOptions() {
        try {
            this.isOptionsList = true;
            const res = await this.requestUpdate();
            if (this.deliveryOptions && res) {
                const list = this.shadowRoot.getElementById("options-list");

                if (!list.classList.contains("d-none")) {
                    list.classList.add("d-none");
                } else {
                    list.classList.remove("d-none");
                }
            }
        } catch (error) {
            throw error;
        }
    }

    async submitReport() {
        try {
            this.submitReportRes = '';
            this.isSystemError = false;
            if (this.selectedDeliveryOption && this.selectedDeliveryIssueReason) {
                const detail = {
                    IssueDate: this.dateFormatForDisplay(this.shadowRoot.getElementById("date-of-issue").value),
                    selectedDeliveryOption: this.selectedDeliveryOption.code,
                    selectedDeliveryIssueReason: this.selectedDeliveryIssueReason.code,
                    subscriptionId: this.subscriptionDetails.subscriptionId,
                }

                const header = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': `Bearer ${this.loginDetails.token}`,
                }

                const body = `IssueDate=${detail.IssueDate}&IssueReason=${detail.selectedDeliveryIssueReason}&RequestedResolution=${detail.selectedDeliveryOption}`;

                const res = await axios.post(`${this.MainServiceDomain}/appservices/api/v2/subscription/${detail.subscriptionId}/deliveryissue`, body, {
                    headers: header
                });

                if (res.data.deliveryIssueId) {
                    this.isReasonsList = false;
                    this.isOptionsList = false;

                    this.submitReportRes = '';
                } else {
                    this.submitReportRes = "Something went wrong";
                }
            } else {
                this.submitReportRes = 'Please select a reason and delivery option';
            }

        } catch (error) {
            if (error.response.data && error.response.data != '' && error.response.data.message && error.status != 500) {
                if (error.response.data.modelState) {
                    this.submitReportRes = error.response.data.modelState['newIssue.IssueDate'][0];
                } else {
                    this.submitReportRes = error.response.data.message;
                }
            } else {
                this.isSystemError = true;
                this.submitReportRes = "System is temporarily unavailable, please try again later";
            }
        }
    }

    cancelReport() {
        this.submitReportRes = '';
        this.selectedDeliveryIssueReason = undefined;
        this.selectedDeliveryOption = undefined;
        this.isReasonsList = false;
        this.isOptionsList = false;
    }

    selectedReason(idx) {
        const description = idx.target.innerText;
        this.selectedDeliveryIssueReason = this.deliveryIssueReasons.find(i => i.description === description);
        this.shadowRoot.getElementById("reasons-list").classList.add("d-none");
    }

    selectedOption(idx) {
        const description = idx.target.innerText;
        this.selectedDeliveryOption = this.deliveryOptions.find(i => i.description === description);
        this.shadowRoot.getElementById("options-list").classList.add("d-none");
    }

    displayDeliveryReason() {
        if (!this.selectedDeliveryIssueReason) {
            return 'select reason';
        } else {
            return this.selectedDeliveryIssueReason.description;
        }
    }

    displayDeliveryOption() {
        if (!this.selectedDeliveryOption) {
            return 'select option';
        } else {
            return this.selectedDeliveryOption.description;
        }
    }
}

customElements.define('syncui-report-delivery-problem', DeliveryProblemComponent);